import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { isMobileOnly } from 'react-device-detect';

import { useDispatch, useSelector } from 'react-redux';
import ChevronLeft from '../Icons/ChevronLeft';
import ArrowLeftIcon from '../Icons/ArrowLeftIcon';
import { logoutUser } from '../../store/actions/user/userActions';
import { PAGES } from '../../constants/pages';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';
import { selectPortalUrl } from '../../store/selectors/settingsSelectors';

const Button = styled.button`
  display: flex;
  align-items: center;
  color: ${({ color }) => color ?? themeColors.colorTextGrey6};
  text-decoration: none;
  font-size: ${variables.typography.p.regular.fontSize};
  font-weight: 400;
  background: none;
  cursor: pointer;
  outline: none;
  border: none;
  width: max-content;

  @media only screen and (max-width: 500px) {
    margin-bottom: 0;
  }
`;
const ChevronLeftIcon = styled(ChevronLeft)`
  margin-right: 13px;
`;

const Back = ({ onClick, color, path, showTitle, isUpgrade }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const portalUrl = useSelector(selectPortalUrl);

  const onBackButtonClick = () => {
    if (isUpgrade) {
      window.location.replace(portalUrl);
      // sessionStorage.clear();
      return;
    }
    if (path === PAGES.BASE) {
      dispatch(logoutUser());
      return;
    }

    if (path) {
      history.push(path);
    }

    return null;
  };

  return (
    <Button onClick={onClick || onBackButtonClick} color={color}>
      {isMobileOnly ? (
        <ArrowLeftIcon color={color} />
      ) : (
        <ChevronLeftIcon color={color} />
      )}
      {showTitle && !isMobileOnly && 'Back'}
    </Button>
  );
};

Back.propTypes = {
  color: PropTypes.string,
  path: PropTypes.string,
  showTitle: PropTypes.bool,
  onClick: PropTypes.func,
  isUpgrade: PropTypes.bool,
};

Back.defaultProps = {
  showTitle: true,
};

export default Back;
